<template>
  <div class="parties_chart">
    <highcharts :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
  export default {
    props: ['data', 'active'],
    data() {
        return {
          active_data: null,
          chartOptions: {
            chart : {
              renderTo : 'container',
              type : 'column',
              showAxes : true,
              marginRight : 0,
              marginLeft : 5,
              spacingRight : 0,
              backgroundColor: null,
              style: {
                fontFamily: 'CeraPro'
              }
            },
            title : {
              text : null
            },
            xAxis : {
              categories : [ 'A', 'B', 'C', 'D', 'E', 'F', 'G' ],
              tickLength : 0,
              lineColor : '#ededed',
              labels: {
                style: {
                  color: '#fff',
                },
                // autoRotation: false;
                useHTML: true,
                formatter : (e) => {
                  return '<span class="x-label "><img src="' + this.logoUrl(e.value.logo_url) + '" /></span>';
                }
              },
            },
            yAxis : {
              gridLineColor : '#555',
              stackLabels: {
                  enabled: true,
                  align: 'center',
                  textOutline: 0,
                  valuePrefix: '€',
                  formatter: function() { 
                    // return this.total;
                    return Math.abs(this.total) > 999 ? '€' + Math.sign(this.total)*((Math.abs(this.total)/1000).toFixed(1)) + 'k' : Math.sign(this.total)*Math.abs(this.total)
                  },
                  style: {
                      color: '#fff',
                      textOutline: 0,
                      fontSize: '14px',
                      fontWeight: 'regular'
                  },
              },
              title : {
                text : null,
              },
              labels : {
                enabled: false,
              }
            },
            legend : {
              enabled : false
            },
            credits : {
              enabled : false
            },
            tooltip: {
              enabled : true
            },
            plotOptions : {
              column: {
                stacking: 'normal',
                pointPadding: 0,
                groupPadding: 0,
                dataLabels: {
                    enabled: false,
                    color: '#FFFFFF'
                }
              },
              series : {
                colorByPoint : true,
                pointWidth : 40,
                borderWidth : 0,
              }
            },
            series : [
              { 
                name : '',
                data : [],
                tooltip: {
                  valuePrefix: '€'
                }
              }
            ]
          }
        }
    },
    mounted() {
    },
    watch: {
      active: {
        handler: function() {
        this.active_data = this.data[this.active.year];
        this.chartOptions.xAxis.categories = this.active_data;
        // console.log(this.chartOptions.xAxis.categories)
        this.chartOptions.series[0].data = [];
        this.active_data.forEach((element, index) => {
          const obj = {
            name: element.name,
            logo_url: element.logo_url,
            y: Math.round(element[this.active.value]),
            color: element.color,
          }
          this.chartOptions.series[0].data.push(obj);
        });
        },
        deep: true
      }
    },
    methods: {
      kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
      },
      logoUrl(url) {
        if(url) {
          return url;
        } else {
          return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII='
        }
      }
    }
  }
</script>